<template>
  <SocialChat icon :attendants="attendants">
    <p slot="header">{{ header }}</p>
    <template v-slot:button>
      <img
        src="https://raw.githubusercontent.com/ktquez/vue-social-chat/master/src/icons/whatsapp.svg"
        alt="icon whatsapp"
        aria-hidden="true"
      />
    </template>
    <small slot="footer">{{ footer }}</small>
  </SocialChat>
</template>
<script>
export default {
  name: "ChatWidget",
  data: () => {
    return {
      fromUrl: "",
      attendants: [],
      header: "",
      footer: "",
      template: "",
    };
  },
  mounted: async function() {
    // this.roles = this.$store.state.roles;
    this.attendants = this.$store.state.whatsapp.attendants;
    this.header = this.$store.state.whatsapp.header;
    this.footer = this.$store.state.whatsapp.footer;
    this.template = this.$store.state.whatsapp.template;
    this.$nextTick(function() {
      var popupLink = this.$el.querySelectorAll(".vsc-popup-body__link");
      // var href = popupLink.getAttribute('href');
      ////console.log(href);
      // popupLink.setAttribute('href',href+'abezebezeh');
      ////console.log(popupLink.getAttribute('href'));
      ////console.log(popupLink);
      popupLink.forEach((el) => {
        var href = el.getAttribute("href");
        ////console.log(href);
        el.setAttribute("href", href + this.template);
        ////console.log(el.getAttribute('href'));
      });
    });
  },
};
</script>
